import { render, staticRenderFns } from "./addHandout.vue?vue&type=template&id=64a28701&scoped=true&"
import script from "./addHandout.vue?vue&type=script&lang=js&"
export * from "./addHandout.vue?vue&type=script&lang=js&"
import style0 from "./addHandout.vue?vue&type=style&index=0&id=64a28701&lang=stylus&scoped=true&"
import style1 from "./addHandout.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a28701",
  null
  
)

export default component.exports